import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/faq/board-shapes.png");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/faq/complexity.jpg");
;
import(/* webpackMode: "eager" */ "/app/apps/royalur/src/app/(articles)/(learn)/faq/opengraph-image.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["GameAPIProvider"] */ "/app/apps/royalur/src/components/api/GameAPIContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscribeToRoyalListPrompt"] */ "/app/apps/royalur/src/components/blog/SubscribeToRoyalListPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EnvProvider"] */ "/app/apps/royalur/src/components/env/EnvContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareButton"] */ "/app/apps/royalur/src/components/layout/ShareButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
